import swipe_hand_icon from '../../blocks/Table/swipe_hand_icon.gif';

/**
 * Converts basic Slate tables to full CMS format with proper styling and containers
 * This ensures Word tables match the exact structure of native CMS tables
 */
export class CMSTableConverter {
  /**
   * Converts all slate-table elements to full CMS format
   * @param {Element} container - The container element to process
   */
  convertSlateTableToCMSFormat(container) {
    const slateTables = container.querySelectorAll('table.slate-table');

    slateTables.forEach((table) => {
      this.transformToCMSTable(table);
    });
  }

  /**
   * Transforms a single table to CMS format
   * @param {Element} table - The table element to transform
   */
  transformToCMSTable(table) {
    // 1. Update table classes to match CMS format
    table.className =
      'ui fixed selectable unstackable very basic table slate-table-block';

    // 2. Fix header cells (convert td to th in thead)
    this.convertHeaderCells(table);

    // 3. Add cell classes and styles
    this.applyCellFormatting(table);

    // 4. Add empty class attributes to sections
    this.addSectionClasses(table);

    // 5. Wrap in CMS containers
    this.wrapInCMSContainers(table);
  }

  /**
   * Converts td elements to th elements in thead section
   * @param {Element} table - The table element
   */
  convertHeaderCells(table) {
    const thead = table.querySelector('thead');
    if (thead) {
      const headerCells = thead.querySelectorAll('td');
      headerCells.forEach((td) => {
        const th = document.createElement('th');
        th.innerHTML = td.innerHTML;
        th.className = 'left aligned top aligned';
        th.style.width = 'auto';
        th.style.minWidth = 'auto';
        th.style.textWrap = 'wrap';
        td.parentNode.replaceChild(th, td);
      });
    }
  }

  /**
   * Applies CMS cell formatting to all td elements
   * @param {Element} table - The table element
   */
  applyCellFormatting(table) {
    const cells = table.querySelectorAll('td');
    cells.forEach((cell) => {
      cell.className = 'left aligned top aligned';
      cell.style.width = 'auto';
      cell.style.minWidth = 'auto';
      cell.style.textWrap = 'wrap';
    });
  }

  /**
   * Adds empty class attributes to table sections and rows
   * @param {Element} table - The table element
   */
  addSectionClasses(table) {
    const thead = table.querySelector('thead');
    const tbody = table.querySelector('tbody');
    const rows = table.querySelectorAll('tr');

    if (thead) thead.className = '';
    if (tbody) tbody.className = '';
    rows.forEach((row) => (row.className = ''));
  }

  /**
   * Wraps the table in the full CMS container structure
   * @param {Element} table - The table element to wrap
   */
  wrapInCMSContainers(table) {
    // Create the scroll container
    const scrollContainer = document.createElement('div');
    scrollContainer.className = 'scroll_gif_container';

    // Create the GIF container and image
    const gifDiv = document.createElement('div');
    const gifImg = document.createElement('img');
    gifImg.alt = 'table_scrollable_animation_gif';
    gifImg.className = 'scroll_gif';
    gifImg.src = swipe_hand_icon;
    gifDiv.appendChild(gifImg);

    // Create the table container
    const tableContainer = document.createElement('div');
    tableContainer.className = 'container-table-block';

    // Insert the container structure before the table
    table.parentNode.insertBefore(scrollContainer, table);

    // Build the container hierarchy
    scrollContainer.appendChild(gifDiv);
    scrollContainer.appendChild(tableContainer);
    tableContainer.appendChild(table);
  }
}
